import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import './NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-page" data-testid="not-found-page">
      <SEO 
        title="Página Não Encontrada"
        description="A página que procura não foi encontrada. Volte à página inicial da AASPS."
      />
      <Header />
      
      <main className="not-found-content">
        <div className="not-found-container">
          <div className="not-found-icon">
            <Search size={80} strokeWidth={1} />
          </div>
          
          <h1 className="not-found-title">404</h1>
          <h2 className="not-found-subtitle">Página Não Encontrada</h2>
          
          <p className="not-found-text">
            A página que procura pode ter sido removida, teve o nome alterado ou está temporariamente indisponível.
          </p>
          
          <div className="not-found-actions">
            <Link to="/" className="not-found-btn primary" data-testid="go-home-btn">
              <Home size={18} />
              Ir para Início
            </Link>
            <button 
              onClick={() => window.history.back()} 
              className="not-found-btn secondary"
              data-testid="go-back-btn"
            >
              <ArrowLeft size={18} />
              Voltar
            </button>
          </div>
          
          <div className="not-found-links">
            <p>Páginas úteis:</p>
            <ul>
              <li><Link to="/contactos">Contactos</Link></li>
              <li><Link to="/institucional">Sobre Nós</Link></li>
              <li><Link to="/projetos">Projetos</Link></li>
              <li><Link to="/noticias">Notícias</Link></li>
            </ul>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFoundPage;
